<template>
<div v-loading.fullscreen.lock="loader">
  <div align="right">
    <el-input v-model="searchText" style="width: 10rem; outline: none;"  prefix-icon="el-icon-search" placeholder="search">
      <!-- <span slot="prefix-icon" class="el-icon-search"></span> -->
    </el-input>
  </div>
  <br>
  <el-table
  :data="filteredData"
  stripe
  height="400"
  style="width: 100%;">
  <el-table-column
    type="index"
    label="Sr. No."
    min-width="100"
  >
  </el-table-column>
  <el-table-column
    prop="first_name"
    align="center"
    label="First Name"
    min-width="150">
  </el-table-column>
  <el-table-column
    prop="last_name"
    align="center"
    label="Last Name"
    min-width="150">
  </el-table-column>
  <el-table-column
    prop="email"
    align="center"
    label="Email Id"
    min-width="220">
  </el-table-column>
  <el-table-column
    prop="status"
    align="center"
    label="Status"
    min-width="220">
  </el-table-column>
  </el-table>
</div>
</template>
<script>
export default {
  props: ['tableData1'],
  data () {
    return {
      searchText: '',
      loader: false
    }
  },
  computed: {
    filteredData () {
      return this.tableData1.filter((ele) => {
        console.log('ELEment First', ele)
        if (ele.first_name !== undefined || ele.first_name !== '') {
          return (ele.first_name.toLowerCase()).match(this.searchText.toLowerCase())
        }
      })
    }
  }
}
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/components/User/UserListTable.vue